// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   VÉLEMÉNYEK SZEKCIÓ (OpinionSection)
   ========================================= */

/* --- ALAP KONTÉNER ÉS SZÖVEGEK --- */
.szakjelentes-create-wrapper .opinion-section {
    background-color: #f9f9f9;
    padding: 20px;
    margin-top: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.szakjelentes-create-wrapper .opinion-section h3 {
    color: #444;
    font-size: 1.6rem;
    margin-bottom: 15px;
}

.szakjelentes-create-wrapper .opinion-section p {
    font-size: 1rem;
    color: #666;
    margin-bottom: 15px;
}

/* --- VÉLEMÉNY DROPZONE (Létrehozás oldalakon) --- */
.szakjelentes-create-wrapper .opinion-dropzone {
    padding: 20px;
    border: 2px dashed #007bff;
    background-color: #eef5ff;
    text-align: center;
    cursor: pointer;
    border-radius: 8px;
    margin-bottom: 15px;
}

.szakjelentes-create-wrapper .opinion-dropzone:hover {
    background-color: #dce9ff;
}

/* --- FELTÖLTÖTT VÉLEMÉNYEK LISTÁJA (Létrehozás oldalakon) --- */
.szakjelentes-create-wrapper .uploaded-opinions-list {
    list-style-type: none;
    padding: 0;
}

.szakjelentes-create-wrapper .uploaded-opinions-list li {
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.szakjelentes-create-wrapper .uploaded-opinions-list li:hover {
    background-color: #f1f1f1;
}

.szakjelentes-create-wrapper .centered-opinion-button {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.szakjelentes-create-wrapper .opinion-button {
    background-color: #44acc9;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.szakjelentes-create-wrapper .opinion-button:hover {
    background-color: #357a9d;
}

/* --- VÉLEMÉNYEZÉS KEZELÉSE (Lezárás/Details oldalon) --- */
.szakjelentes-create-wrapper .opinion-input {
    width: 100%;
    height: 80px;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.szakjelentes-create-wrapper .opinion-submit-button {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #44ACC9;
    color: white;
    border: none;
    cursor: pointer;
}

.szakjelentes-create-wrapper .opinion-submit-button:hover:not(:disabled) {
    background-color: #357a9d;
}

/* Disabled (inaktív) állapot 5-ös státusznál */
.szakjelentes-create-wrapper .opinion-submit-button:disabled {
    background-color: #d4d4d4 !important;
    color: #5e5e5e !important;
    cursor: not-allowed !important;
    border: 1px solid #c0c0c0 !important;
    box-shadow: none !important;
    transform: none !important;
}

.szakjelentes-create-wrapper .opinions-list {
    margin-top: 20px;
    list-style: none;
    padding: 0;
}

.szakjelentes-create-wrapper .opinion-item {
    background: #f9f9f9;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.szakjelentes-create-wrapper .opinion-delete-button {
    background: red;
    color: white;
    border: none;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/szakjelentesCreate/OpinionSection.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C,sCAAsC;AACtC;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iEAAiE;AACjE;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4DAA4D;AAC5D;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+CAA+C;AAC/C;IACI,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB","sourcesContent":["/* =========================================\n   VÉLEMÉNYEK SZEKCIÓ (OpinionSection)\n   ========================================= */\n\n/* --- ALAP KONTÉNER ÉS SZÖVEGEK --- */\n.szakjelentes-create-wrapper .opinion-section {\n    background-color: #f9f9f9;\n    padding: 20px;\n    margin-top: 30px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.szakjelentes-create-wrapper .opinion-section h3 {\n    color: #444;\n    font-size: 1.6rem;\n    margin-bottom: 15px;\n}\n\n.szakjelentes-create-wrapper .opinion-section p {\n    font-size: 1rem;\n    color: #666;\n    margin-bottom: 15px;\n}\n\n/* --- VÉLEMÉNY DROPZONE (Létrehozás oldalakon) --- */\n.szakjelentes-create-wrapper .opinion-dropzone {\n    padding: 20px;\n    border: 2px dashed #007bff;\n    background-color: #eef5ff;\n    text-align: center;\n    cursor: pointer;\n    border-radius: 8px;\n    margin-bottom: 15px;\n}\n\n.szakjelentes-create-wrapper .opinion-dropzone:hover {\n    background-color: #dce9ff;\n}\n\n/* --- FELTÖLTÖTT VÉLEMÉNYEK LISTÁJA (Létrehozás oldalakon) --- */\n.szakjelentes-create-wrapper .uploaded-opinions-list {\n    list-style-type: none;\n    padding: 0;\n}\n\n.szakjelentes-create-wrapper .uploaded-opinions-list li {\n    display: flex;\n    align-items: center;\n    padding: 8px 0;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.szakjelentes-create-wrapper .uploaded-opinions-list li:hover {\n    background-color: #f1f1f1;\n}\n\n.szakjelentes-create-wrapper .centered-opinion-button {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n}\n\n.szakjelentes-create-wrapper .opinion-button {\n    background-color: #44acc9;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.szakjelentes-create-wrapper .opinion-button:hover {\n    background-color: #357a9d;\n}\n\n/* --- VÉLEMÉNYEZÉS KEZELÉSE (Lezárás/Details oldalon) --- */\n.szakjelentes-create-wrapper .opinion-input {\n    width: 100%;\n    height: 80px;\n    padding: 10px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n}\n\n.szakjelentes-create-wrapper .opinion-submit-button {\n    margin-top: 10px;\n    padding: 8px 12px;\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    cursor: pointer;\n}\n\n.szakjelentes-create-wrapper .opinion-submit-button:hover:not(:disabled) {\n    background-color: #357a9d;\n}\n\n/* Disabled (inaktív) állapot 5-ös státusznál */\n.szakjelentes-create-wrapper .opinion-submit-button:disabled {\n    background-color: #d4d4d4 !important;\n    color: #5e5e5e !important;\n    cursor: not-allowed !important;\n    border: 1px solid #c0c0c0 !important;\n    box-shadow: none !important;\n    transform: none !important;\n}\n\n.szakjelentes-create-wrapper .opinions-list {\n    margin-top: 20px;\n    list-style: none;\n    padding: 0;\n}\n\n.szakjelentes-create-wrapper .opinion-item {\n    background: #f9f9f9;\n    padding: 10px;\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 5px;\n}\n\n.szakjelentes-create-wrapper .opinion-delete-button {\n    background: red;\n    color: white;\n    border: none;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
